



































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import ChatbotDocumentsModal from '../modals/chatbotDocumentsModal.vue';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'chatbot-documents',
    data: function () {
        return {
            chatbotDocumentsPage_: 1,
            question: '',
            new_message: '',
        };
    },
    components: {
        ChatbotDocumentsModal,
        Spinner,
    },
    computed: {
        ...mapState('chatbotDocuments', [
            'allChatbotDocuments',
            'allChatbotDocumentsLoading',
            'activeChatbotDocumentLoading',
            'activeChatbotDocument',
            'chatbotDocumentsPerPage',
            'chatbotDocumentsPage',
            'chatbotDocumentsTotal',
            'activeChatbotDocument.sku_document'
        ]),
        ...mapState('auth', ['currentUser']),
    },
})
export default class ChatbotDocuments extends Vue {
    private now: Date = new Date();//Objeto para poder obtener el tiempo de la computadora
    //Crear 2 variables diferentes uno para el tiempo del asistente y otro para el tiempo del usuario y crear un v-else en el span de la hora y sacar hora y minuto solamente
    private time_user!: any;
    private time_assistant!: any;
    private no_message: boolean = false; 
    public allChatbotDocuments!: any;
    public activeChatbotDocumentLoading!: any;
    public allChatbotDocumentsLoading!: any;
    public assistant_search: any = '';
    public ordersPerPage!: any;
    public ordersPage!: any;
    public ordersTotal!: any;
    public question!: any;
    public human: string = '';
    public messages: { text: string; isFromAPI: boolean }[] = [];//Lista de mensajes
    public loading_messages: false;//Loading de los mensajes
    public new_message: string = ' ';//nuevo mensaje, este sirve para el v-model
    public new_summary: string = '';
    public bot: string = '';
    public botloading: boolean = false;
    public open_chat_modal: boolean = false;
    private activeFilters: boolean = false;
    // public botLoading!: any;
    public chatbotDocumentsPerPage!: any;
    public chatbotDocumentsPage!: any;
    public chatbotDocumentsTotal!: any;
    public chatbotDocumentsPage_!: any;
    private deletechat = '';// no eliminar
    public noDocument!: any;
    // public no_documents_chat = this.chatbotDocuments.
    
    

    allChatbotDocumentsHeaders = [
        { thClass: 'th', key: 'id', label: 'ID' },
        { thClass: 'th', key: 'assistant_name', label: 'Nombre' },
        { thClass: 'th', key: 'edit', label: '' },
        { thClass: 'th', key: 'chat', label: '' },
        { thClass: 'th', key: 'delete', label: '' },
    ];

    private currentUser!: any;

    canSee(roles: any) {
        let roleValidation = false;
        let user1Id = '8c39c042-be3d-4e7c-9f54-a840d655fe14'; //montufar
        let userdId = '85c1e50c-01de-4365-991f-e6fd5d52d90a'; //development
        switch (this.currentUser.role.name) {
            case 'Admin':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'Developer':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'MercadoLibre Manager':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                // if (this.currentUser.id != user1Id && this.currentUser.id != userdId) {
                //     roleValidation = false;
                // }
                break;
            default:
                roleValidation = false;
                break;
    }
    return roleValidation;
}

    @Watch('$route')
    onRouteChange() {
        this.getAllChatbotDocuments();
    }

    get allChatbotDocumentsCollection() {
        return this.allChatbotDocuments.filter((cat) => {
            return (
                cat.assistant_name.includes(this.assistant_search) ||
                cat.assistant_name.toLowerCase().includes(this.assistant_search) ||
                cat.assistant_name.toUpperCase().includes(this.assistant_search)
            );
        });
    }

    setUrlSort(ctx: any) {
        this.$router.push({
            path: 'chatbot-documents',
            query: {
                ...this.$route.query,
                sortName: ctx.sortBy,
                sortValue: ctx.sortDesc ? 'desc' : 'asc',
            },
        });
    }

    setUrlSearch(search: string) {
        this.$router.push({
            path: 'chatbot-documents',
            query: {
                ...this.$route.query,
                search,
            },
        });
    }

    clearFilters() {
        this.$router.push({
            path: 'orders',
            query: {},
        });
    }

    getAllChatbotDocuments() {
        console.log(this.$route);
        const page = this.$route.query.page || 1;
        const search = this.$route.query.search || null;

        this.$store.dispatch('chatbotDocuments/getAll', {
            page,
            search,
        });
    }

    async onOpenAssistantModal(id: number | null = null) {
        if (id == null) {
            this.noDocument = await this.$store.dispatch('chatbotDocuments/getOne', 0);

            setTimeout(() => {
                this.$bvModal.show('chatbot-documents-modal');
            }, 400);
        } else {
            this.$store.dispatch('chatbotDocuments/getOne', id);
            setTimeout(() => {
                this.$bvModal.show('chatbot-documents-modal');
            }, 400);
        }
    }



    showChatModal(id) {
        this.$bvModal.show(`modalChat-${id}`);
        this.open_chat_modal = true;
        console.log(id);
        // this.$store.dispatch('ai_assistants/getOne', id);
        
    }

    onSendQuestion() {
        this.human = this.question;
        this.question = '';
        if (this.open_chat_modal) {
            this.bot = '';
        }
        this.botloading = true;
        
        return this.human;
    }

    async onAnswerQuestion(data: any, human) {
        try {
            this.noDocument = await this.$store.dispatch('chatbotDocuments/getOne', data.id)
            let assistant_name = data.assistant_name;
            if (this.noDocument.sku_document == null || this.noDocument.sku_document.length == 0) {
                this.bot = 'Hola aún no puedo darte una buena respuesta porque no cuento con documentos específicos';
                this.botloading = false;
            } else {
                // this.bot = await this.$store.dispatch('chatbotDocuments/getAnswer', { assistant_name, human, vm: this });
                let answersummary = await this.$store.dispatch('chatbotDocuments/getAnswerSummary', {assistant_name, human, vm: this})
                console.log(answersummary);
                this.botloading = false;}
        } catch (error) {
            console.log(error);
            this.bot = 'Ha ocurrido un error en el sistema, vuelve a intentarlo';
            this.botloading = false;
        }

        console.log(this.human);
        return this.bot;
    }

    async sendMessage(data: any){
        let assistant_name = data.assistant_name;
        console.log(data);
        let human, answersummary, summary;
        try {
            this.new_message = this.new_message.trim()
            if (this.new_message !== '' && this.new_message!== undefined) {
                this.no_message = true;//Para verificar que no se envíe el usuario ni el mensaje vacío
                const userMessage = { text: this.new_message.trim(), isFromAPI: false };
                human = this.new_message;
                this.time_user = this.calculateTime();
                console.log(human);
                this.messages.push(userMessage); // Agregar el item del usuario
                this.new_message = ''; // Limpiar el input
                this.botloading = true;
                if (this.new_summary != '') {
                    summary = this.new_summary
                    answersummary = await this.$store.dispatch('chatbotDocuments/getAnswerSummary', {assistant_name, human, summary, vm: this})
                }
                else{
                    answersummary = await this.$store.dispatch('chatbotDocuments/getAnswerSummary', {assistant_name, human, vm: this})
                }
                this.new_summary = answersummary.summary
                const assistant_message = { text: answersummary.response, isFromAPI: true };
                human = this.new_message;
                this.time_assistant = this.calculateTime();
                // Agregar el item de la API a la lista
                this.botloading = false;
                this.messages.push(assistant_message);
                console.log(answersummary);
            }
        } catch (error) {
            this.botloading = false;
        }
        
    }

    //Método para saber que hora es en la computadora
    calculateTime(){
        let hour, minute,time
        hour = this.now.getHours();
        minute = this.now.getMinutes();
        time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        return time
    }

    mounted() {
        this.getAllChatbotDocuments();
        this.ordersPage = 1;
    }
    resetAnswer(name) {
        this.bot = '';
        this.human = '';
        this.messages = [];
        this.new_summary = '';
        this.hideModal(name);
    }

    setUrlPage(page: any) {
        // @ts-ignore
        this.$router.push({
            path: 'chatbot-documents',
            query: {
                ...this.$route.query,
                page,
            },
        });
        this.chatbotDocumentsPage_ = page;
    }
    hideModal(name: string) {
        this.$bvModal.hide(name);
        this.open_chat_modal = false;
    }

    DeleteChatbot(id: any, assistant_name: any) {
        
        this.$bvModal
            .msgBoxConfirm(`¿Esta seguro que desea eliminar este documento el asistente ${assistant_name}?`, 
            {
                title: 'Eliminar',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Eliminar',
                cancelTitle: 'Cancelar',
                footerClass: 'p-2',
            })
            .then(async (value: any) => {
                if (value) {
                    this.deletechat = await this.$store.dispatch('chatbotDocuments/deleteOne', { assistant_name, id, vm: this });
                    this.getAllChatbotDocuments();
                }
            })
            .catch((err) => {
                console.log(err);
                
            });
    }
}
